import { observer } from "mobx-react-lite";
import styled from "@emotion/styled";
import { MdsIconKind } from "@/design-system/components/icon";
import { useAppStore } from "@/store";
import { ZIndex } from "@/domains/design/constants";
import { SidebarContents } from "@/components/layout/components/sidebar/sidebar-contents";
import { useState } from "react";
import { SidebarAccountInfo } from "@/components/layout/components/sidebar/SidebarAccountInfo";
import { SidebarDropdownMenu } from "@/components/layout/components/sidebar/SidebarDropdownMenu";
import { css } from "@/domains/emotion";
import { ProfileSize } from "@/components/layout/components/account-profile";
import { motion } from "motion/react";
import { TOP_BAR_HEIGHT } from "@/components/layout/components/constants";
import { MDSIconButton } from "@/mds";

export const SidebarMobile = observer(
  ({
    onClick,
    setIsImportModalOpen,
  }: {
    onClick: () => void;
    setIsImportModalOpen: (b: boolean) => void;
  }) => {
    const { store } = useAppStore();
    const { profileDisplayName, profilePhotoUrl, profileEmailAddress } = store.account.myAccount;
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
      <Wrapper
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.12, ease: "easeInOut" }}
      >
        <ContainerTop>
          {isMenuOpen && (
            <MDSIconButton iconKind={MdsIconKind.LeftArrow} onClick={() => setIsMenuOpen(false)} />
          )}
          <SidebarAccountInfo
            profileSize={ProfileSize.Large}
            profileDisplayName={profileDisplayName}
            profilePhotoUrl={profilePhotoUrl}
            profileEmailAddress={profileEmailAddress}
          />
          {!isMenuOpen && (
            <MDSIconButton
              iconKind={MdsIconKind.AngleRight}
              onClick={() => setIsMenuOpen(true)}
              className={alignRightStyles}
            />
          )}
        </ContainerTop>
        {isMenuOpen ? (
          <SidebarDropdownMenu
            className={dropdownStyles}
            onClick={onClick}
            setIsImportModalOpen={setIsImportModalOpen}
          />
        ) : (
          <SidebarContentsWrapper>
            <SidebarContents onClick={onClick} />
          </SidebarContentsWrapper>
        )}
      </Wrapper>
    );
  }
);

const Wrapper = styled(motion.div)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: theme.spacing.xs,
  backgroundColor: theme.colors.surface.menu,
  height: `calc(100dvh - 6px - ${TOP_BAR_HEIGHT}px)`,
  width: "calc(100dvw)",
  position: "absolute",
  top: `calc(${TOP_BAR_HEIGHT}px)`,
  borderTopLeftRadius: theme.borderRadius.large,
  zIndex: ZIndex.Sidebar,
}));

const ContainerTop = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  padding: theme.spacing.md,
  gap: theme.spacing.xs,
  borderBottom: `1px solid ${theme.colors.border.default}`,
}));

const SidebarContentsWrapper = styled.div(({ theme }) => ({
  overflowY: "scroll",
  padding: theme.spacing.sm,
}));

const dropdownStyles = css({
  backgroundColor: `transparent`,
  boxShadow: `none`,
  width: `100%`,
  border: 0,
  height: "auto",
});

const alignRightStyles = css({
  marginLeft: "auto",
});
